import { http, HttpResponse } from 'msw';
import { apiUrl } from '../apiUrl';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { db } from '../../db/db';

export const mockUpdateName = http.post(apiUrl(AccountApiPaths.updateName), () => HttpResponse.json());
export const mockUploadProfileImage = http.post(apiUrl(AccountApiPaths.uploadProfileImage), () => HttpResponse.json());
export const userImageQuery = http.get(apiUrl(AccountApiPaths.userImage), () =>
    HttpResponse.json(undefined, { status: 404 })
);

export const userInfoQuery = http.get(apiUrl(AccountApiPaths.userInfo), () => {
    const userInfo = db.userInfo.getAll()[0];
    return HttpResponse.json(userInfo);
});

export const accountHandlers = [userImageQuery, userInfoQuery, mockUploadProfileImage, mockUpdateName];
